import { defineComponent as _defineComponent } from 'vue'
interface Props {}


export default /*#__PURE__*/_defineComponent({
  __name: 'text-label',
  setup(__props: any, { expose: __expose }) {
  __expose();



const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})